import styled from 'styled-components'
export const WorkSection = styled.div `
    padding: 70px 0 100px;
    overflow:hidden;
    background-color: #2C1342

`
export const WorkTitle = styled.div `
    font-size: 60px;
    font-family: 'Great Vibes', cursive;
    margin-bottom: 30px;
    color:#fff;
    text-shadow:
    0 1px #808d93,
    -1px 0 #cdd2d5,
    -1px 2px #808d93,
    -2px 1px #cdd2d5,
    -2px 3px #808d93,
    -3px 2px #cdd2d5,
    -3px 4px #808d93,
    -4px 3px #cdd2d5,
    -4px 5px #808d93,
    -5px 4px #cdd2d5,
    -5px 6px #808d93,
    -6px 5px #cdd2d5,
    -6px 7px #808d93,
    -7px 6px #cdd2d5,
    -7px 8px #808d93,
    -8px 7px #cdd2d5;
`
export const Card = styled.div `
   background-color: #26052f; 
`
export const Span = styled.span `
   color: #FA9E19;
   padding: 50px 0;
`
export const Hr = styled.hr `
   width: 60%;
   margin: auto;
   background-color: #FA9E19;
`
export const CardTitle = styled.h5 `
   color: #FA9E19;
  
`
